import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authService } from "../../commons";
import { StatusEnum } from "../../commons/enums/status-enum";
import { IUserDTO } from "../../api-services/manage-user-service";

export interface IAuthMeEditOption {
  authUserData: IUserDTO;
}

const initialState = {
  authUserStatus: StatusEnum.Idle,
};

export const profileEdit = createAsyncThunk("authMeEdit", async (options: IAuthMeEditOption, thunkAPI) => {
  try {
    const authUserResponse = await authService.editAuthUser(options.authUserData);
    return authUserResponse;
  } catch (e) {
    return thunkAPI.rejectWithValue(e);
  }
});

const authMeEditSlice = createSlice({
  name: "auth-me-edit",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(profileEdit.pending, (state) => {
        state.authUserStatus = StatusEnum.Loading;
      })
      .addCase(profileEdit.fulfilled, (state, action) => {
        state.authUserStatus = StatusEnum.Succeeded;
      })
      .addCase(profileEdit.rejected, (state) => {
        state.authUserStatus = StatusEnum.Failed;
      });
  },
});

export default authMeEditSlice.reducer;
